export default [
    {
        id: 1,
        nome: "Luana Barbosa",
        stars: 5,
        color: "#3086FF",
        txt: "Super dedicado no que faz !Ele cuida da minha empresa a 3 anos… resultados maravilhosos junto a essa empresa… confio demais. Ótimo profissional, super indico quem quer alavancar o seu negocio.",
    },
    {
        id: 2,
        nome: "Jose Luiz",
        stars: 5,
        color: "#299981",
        txt: "Super indico. Prestativo educado tá disposto a nos ajudar sempre, dando ideias pra evolução, apoiando com ideias novas. Tudo de bom.",
    },
    {
        id: 3,
        nome: "Simoni Ferreira",
        stars: 5,
        color: "#d31b1b",
        txt: "",
    },
    {
        id: 4,
        nome: "César Benitez",
        stars: 5,
        color: "#2d9373",
        txt: "Resultados garantidos! profissional com ampla experiência #indico",
    },
    {
        id: 5,
        nome: "Rodrigo Santana",
        stars: 5,
        color: "#67419d",
        txt: "Ótimo profissional. Sabe o que faz e esta sempre se atualizando",
    },
    {
        id: 6,
        nome: "Juliano Gomes da Costa",
        stars: 5,
        color: "#2087a1",
        txt: "Excelente! Muito profissional e com muito conhecimento de google adwords. Tem muita gestor de tráfego por aí, mas poucos com o profissionalismo e comprometimento que a Awaken oferece, parabéns.",
    },
    {
        id: 7,
        nome: "Vitor Augusto Maiorky",
        stars: 5,
        color: "#767676",
        txt: "Recomendo os serviços da Awaken. Anderson é um especialista em Ads, super atencioso, superou nossas expectativas. Google é uma ferramenta que não podemos ficar sem e ele realmente sabe oq está fazendo.",
    },
    {
        id: 8,
        nome: "Robson Galias",
        stars: 5,
        color: "#5b8227",
        txt: "Parceiro de todas as horas. Competente no que faz. Qq questão relativa ao Google, eles resolvem. Vlw e vamos em frente!",
    },
    {
        id: 9,
        nome: "Tiago Ferreira",
        stars: 5,
        color: "#176adf",
        txt: "Ótima. Trabalho feito com excelência",
    },
    {
        id: 10,
        nome: "Cristina artes em crochê",
        stars: 5,
        color: "#aa1c1c",
        txt: "Excelente profissional",
    },
    {
        id: 11,
        nome: "Hercules Forte",
        stars: 5,
        color: "#72297e",
        txt: "Serviço e atendimento top 💪🏽",
    },
    {
        id: 12,
        nome: "Alisson Vieira",
        stars: 5,
        color: "#3a3a3a",
        txt: "Otimo atendimento do Anderson, profissional e focado em resultado, explicando bem cada etapa do processo e buscando campanhas mais eficientes. Recomendo muito a awaken para empresas e negócios que querem melhorar sua presença no Google.",
    },
]